import React from "react";
import { useLang } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import { SectionHeading } from "./Services";

export default function Monitoring() {
  const { t } = useLang();
  const m = t.monitoring;
  const ref = useReveal();

  return (
    <section id="monitoreo" className="bg-[#0d2140] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading eyebrow={m.eyebrow} title={m.title} subtitle={m.subtitle} dark />

        <div ref={ref} className="reveal mt-14 grid lg:grid-cols-2 gap-10 items-center">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img src={m.img} alt={m.title} className="w-full h-[420px] object-cover" />
            <span className="absolute top-4 left-4 inline-flex items-center gap-2 bg-red-600 text-white text-xs font-700 uppercase tracking-widest px-3 py-1.5 rounded-full font-display">
              <span className="w-2 h-2 rounded-full bg-white live-dot" />
              {m.live}
            </span>
          </div>

          <div>
            <div className="grid grid-cols-2 gap-5">
              {m.stats.map((s, i) => (
                <div key={i} className="rounded-2xl bg-[#12294c] border-t-2 border-[#f5871f] px-6 py-6">
                  <div className="font-display font-700 text-4xl text-white">{s.value}</div>
                  <div className="text-white/60 text-xs uppercase tracking-widest mt-1 font-display">{s.label}</div>
                </div>
              ))}
            </div>
            <p className="mt-6 text-white/65 text-sm md:text-base leading-relaxed">{m.footer}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
